<template>
	<div id="body-container">
		<navbar :class="{active:'bg-dark'}"/>
		<div class="SessionPopup">
			<SessionPopup />
		</div>
		<div class="overlay" :class="{ active: 'isOverlayActive' }" v-if="isSessionPopupVisible == true"></div> <!-- Overlay here -->
		<div class="flex bg-dark" @click="closeApps()">
			<div :class="{ 'w-40': isToggling, 'w-10': !isToggling ,active:'bg-dark-blue'}">
				<sidemenubar />
			</div>
			<div class="content mt-12 flex-1 min-w-0 w-full overflow-hidden" :class="{ toggledstate: isToggling }"  @scroll="handleScroll">
				<div class="page" :class="pagePadding()">
					<slot />
				</div>
				<Footer />	
			</div>
		</div>
		<detailsModalHost />
	</div>
</template>
<style  scoped>
.content {
	height: calc(100vh - 3rem);
	display: flex;
	flex-direction: column;
	min-height: 0;
}
.page{
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	margin-bottom: 0;
	padding-bottom: 30px;
}
.page:has(.page-fill) {
	overflow: hidden;
}
.pagepadding{
	margin-bottom: 75px;
}
.pagepadding0{
	padding-bottom: 0px;
}

.SessionPopup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
  z-index: 99999; /* Ensure it's above other content */
}
.bg-dark.active {
  /* background-color:rgba(8, 8, 8, 0.5); */
  opacity:0.7;
  z-index:50;
}
.bg-dark-blue{
	/* background-color:rgba(0, 0, 0, 0.5); */
	opacity: 0.7; 
}
.bg-dark-blue.active{
	/* background-color:rgba(0, 0, 0, 0.5); */
	opacity: 0.7;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* Black with opacity */
  z-index: 9999;
  display: none; /* Initially hidden */
}

.overlay.active {
  display: block; /* Show the overlay when active */
}
</style>
 <script lang="ts">
import navbar from '@/components/navbar.vue';
import sidemenubar from '@/components/sidemenubar.vue';
import Footer from '@/components/footer.vue'
import { defineComponent } from 'vue';
import { emitter } from '../main';
import { mapGetters } from 'vuex';
import SessionPopup from '@/components/sessionpopup.vue';
import detailsModalHost from '@/components/detailsModalHost.vue';

export default defineComponent({
	components: {
		navbar,
		sidemenubar,
		Footer,
		SessionPopup,
		detailsModalHost
	},
	data() {
		return {
			isToggling: true,
			appsVisible:false,
			isSessionPopupVisible:false
		};
	},
	computed:{
		...mapGetters({ selectedOptionName: 'val',toggleState:'toggle' })
	},
	methods:{
		closeApps(){
			this.appsVisible=false;
		emitter.emit('apps', this.appsVisible);
		},
		handleScroll() {
			if (this.$route.path.includes('/audit')){
				emitter.emit('close-dropdown'); // Emit event to close dropdown on scroll
			}
		},
		pagePadding(){
			if(this.$route.name=='add-audit'){
				return 'pagepadding0'
			}
			return ''
		}
	},

	mounted() {
		this.isToggling = this.toggleState;
		emitter.on('toggle-sidebar', (isToggle: any) => {
			this.isToggling = isToggle;
		});
		emitter.off('isvisible');
		emitter.on('isvisible',(data:any)=>{
			this.isSessionPopupVisible = data;

		})
	}
});
</script>